<template>
    <div class="ft-box">
        <div class="ft-title aFlex">
            <!-- <Icon class="ft-title-mark" type="md-bookmark" /> -->
            <span>出勤统计</span>
            <DatePicker style="margin-left: auto;" type="month"
                         placeholder="请选择" transfer
                        :clearable="false" :options="options"
                        :value="currDate" @on-change="handleDate" ></DatePicker>
        </div>
        <div class="fchart-bi" style="border: none" id="attendanceTrend" ref="attendanceTrend">人员考勤趋势</div>
    </div>

</template>
<script>
import * as echarts from 'echarts';
export default {
  data(){
    return {
      arrDate: [],//获取日历的数据
      date: [],// 获取日历中所有日期
      flag: [],//获取日历中所有状态
      chartTrend: null,
      currDate: '',
      // 日期配置
      options: {
        disabledDate (date) {
          return date && date.valueOf() > Date.now();
        }
      },
    };
  },
  props: {
    workerId:{
      type: [String,Number]
    },
    corpId:{
      type: [String,Number]
    },
    projectId:{
      type: [String,Number]
    },
    trendData:{
      type:Object,
      default:()=>{}
    },
  },
  watch:{
    trendData:{
      handler(newVal,oldVal){
        if(newVal){
          this.arrDate= newVal.calendar;
          this.date = [], this.flag = [];
          this.arrDate.forEach(item => {
            this.date.push(item.date);
            this.flag.push(item.flag ? 2 : 1);
          });
        }
      },
      deep:true,
      immediate:true
    }
  },
  computed: {

  },
  created(){
    const date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    month = month > 9 ? month : '0' + month;
    this.currDate=`${year}-${month}`;
  },
  mounted(){
    this.chartTrend = echarts.init(this.$refs.attendanceTrend);
    window.addEventListener('resize',this.resize);
    /*加载完成自适应*/
    this.$nextTick( ()=> {
      this.resize();
    });
    this.getPageData();
  },
  // watch: {

  // },
  methods: {
    // 日期变化获取考勤列表数据
    getCheckList(){
      this.loading=true;
      // this.$nextTick(() => {
      this.axios({
        method: 'get',
        url: '/project/workers/oneProjectCalendar',
        params:{
          // workerId:'10344',
          workerId:this.workerId,
          projectId:this.trendData.projectId,
          // corpId:this.corpId,
          date:this.currDate,
        }
      }).then( (response)=> {
        this.loading=false;
        if (response.data.success){
          console.log('cccccccccccc',response);
          this.arrDate= response.data.data[0].calendar;
          this.date = [], this.flag = [];
          this.arrDate.forEach(item => {
            this.date.push(item.date);
            this.flag.push(item.flag ? 2 : 1);
          });
          this.getPageData();



        }
      }).catch( ()=> {
        this.loading=false;
      });
      // })

    },
    // echarts 适应
    resize(){
      this.chartTrend.resize();
    },
    // 日期改变
    handleDate(str){
      this.currDate=str;
      this.getCheckList();
    },
    getPageData() {
      this.chartTrend.setOption(
        {
          title: {
            // text: '出勤统计'
          },
          legend: {

          },
          tooltip: {
            formatter: (params) => {
              if(params.data === 2) {
                return params.name+' 出勤';
              }else if(params.data === 1) {
                return params.name+' 未出勤';
              }else {
                return '';
              }

            }
          },
          grid:{
            left: 16,
            right: 16,
            // top: 40,
            // bottom: 5,
            containLabel: true
          },
          xAxis:{
            /* 类目轴*/
            type:'category',
            axisLabel:{
              show: true,
              // interval: 0,
            },
            splitLine: {
              show: true, //网格线开关
              interval: 0 ,
              lineStyle:{
                type:'solid',
              }
            },
            axisTick: {
              alignWithLabel: true
            },
            data:this.date
          },
          yAxis:{
            name:'',
            nameTextStyle:{

            },
            splitLine: {
              show: true, //网格线开关
              lineStyle:{
                type:'solid'
              }
            },
            axisLine:{
              show: true
            },
            axisLabel: {
              formatter: (value) => {
                if(value === 2) {
                  return '出勤';
                }else if(value === 1) {
                  return '未出勤';
                }else {
                  return '';
                }
              }
            },
            minInterval: 1,
          },
          color: [ '#3399FF','#61DDAA','#65789B'],
          series: [
            {
              type: 'scatter',
              name: '',
              symbol: 'circle' ,
              symbolSize: 15,
              itemStyle: {
                color: (params) => {
                  if(new Date(params.name) > Date.now()) {
                    return '#cccccc';
                  }
                  console.log(params,55555555);
                  if(params.value === 2) {
                    return '#99CC33';
                  }else {
                    return '#F85546';
                  }
                }
              },
              data:this.flag,
            },
          ]
        }
      );
    },
  }
};
</script>
<style scoped lang="less">
    
    .calendar{
        width: 100%;
    }
    .cal-top{
        display: flex;
        align-items: center;
        height: 80px;
    }
    .cal-title{
        font-size: 16px;
        color: #333333;
        font-weight: 700;
        margin-right: 20px;
    }
    .cal-dot{
        width: 15px;
        height: 15px;
        border-radius: 50%;
    }
    .cal-dot.green{
        background-color: #99CC33;
    }
    .cal-dot.red{
        background-color: #CC3300;
    }
    .cal-box{
        border-top: 1px solid #dcdee2;
        border-left: 1px solid #dcdee2;
        position: relative;
    }
    .cal-weeks,.cal-days{
        display: flex;
        flex-wrap: wrap;
        position: relative;
    }
    
    /* 每一项 */
    .cal-item{
        width:14.2857% ;
        padding: 10px 5px;
        text-align: center;
        border-right:1px solid #dcdee2;
        border-bottom:1px solid #dcdee2;
    }
    /* 星期 */
    .cal-weeks .cal-item{
        background-color: #F5F5F5;
        font-weight: 700;
        font-size: 14px;
        color: #333333;
    }
    /* 天 */
    .cal-days .cal-item{
        height: 60px;
    }
    .cal-item-conten{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .cal-item-other{
        color: #cccccc;
    }
</style>

